import { Accordion } from "@scott/ui/elements/accordion";
import type { ReactNode } from "react";
import type { AccordionPageBlock } from "@/types/page-block";
import type { PageContext } from "@/types/page-context";
import { ContentBlocks } from "./content-blocks";

export type AccordionBlockProps = AccordionPageBlock & {
  pageContext: PageContext["pageContext"];
};

export function AccordionBlock(
  props: Readonly<AccordionBlockProps>
): ReactNode {
  const items = props.items.map((item, index) => ({
    id: item.id ?? `${props.id}-item-${index}`,
    label: item.label,
    children: (
      <ContentBlocks blocks={item.children} pageContext={props.pageContext} />
    ),
  }));

  return (
    <Accordion
      backgroundColor={props.uiConfiguration?.backgroundColor}
      color={props.uiConfiguration?.textColor}
      columnWidth={props.columnWidth}
      items={items}
      mode="D2C"
      paddingBottom={props.uiConfiguration?.paddingBottom}
      paddingTop={props.uiConfiguration?.paddingTop}
      sys={props.sys}
    />
  );
}
